import connector from '../../connector.js'

/**
 * Get auth token for export user
 */
export function getToken () {
  return connector.get('auth/export-token/acquire').json()
}

/**
 * Revoke all auth tokens for export user
 */
export function revokeTokens () {
  return connector.get('auth/export-token/nuke-from-orbit').json()
}